import * as types from './types';
import { tabEnum } from '../../../../sitesetup/helpers/SiteSetupConstants';

const INITIAL_STATE = {
  selectedTab: tabEnum.SITE_DETAILS,
  isGridLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEM_MAINTENANCE_SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };

    case types.ITEM_MAINTENANCE_GRID_LOADING:
      return {
        ...state,
        isGridLoading: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/settings/reducer.js